// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueQuillEditor from 'vue-quill-editor'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(Antd);
Vue.use(VueQuillEditor);
Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
Vue.use(ElementUI)
import store from './store'
import Vuex from 'vuex'
Vue.prototype.Global =  process.env.NODE_ENV === 'development' ? '/jtd/' : '/'
Vue.use(Vuex)
// import '@/assets/svg.js'
import MisIcon from '@/views/MisIcon.vue' // svg组件

// 注册全局插件
Vue.component('mis-icon', MisIcon)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  // store,
  store:store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js